import React, { useState } from 'react'
import { Box, Link } from 'theme-ui'

import BaseButton from 'src/components/common/buttons/BaseButton'

export interface MenuDropdownProps {
  headerItem: {
    label: string
    items: { label: string; url: string }[]
  }
}

const MenuDropdown = ({ headerItem }: MenuDropdownProps) => {
  const [open, setOpen] = useState(false)

  const handleToggle = () => setOpen(prev => !prev)
  const handleBlur = (e: React.FocusEvent) => {
    if (!e.currentTarget.contains(e.relatedTarget as Node)) setOpen(false)
  }

  return (
    <Box
      sx={{
        position: ['static', null, null, null, 'relative'],
        display: ['block', null, null, null, 'inline-block'],
        width: ['100%', null, null, null, 'auto'],
        pr: 2,
        pt: 1
      }}
      onBlur={handleBlur}
    >
      <BaseButton
        onClick={handleToggle}
        aria-haspopup="menu"
        aria-expanded={open}
        variant="buttons.navigation"
        className={open ? 'navigationActive' : ''}
        text={headerItem.label}
        rightIcon="GelIconChevronDown"
        iconDimensions={{ width: '16px', height: '16px' }}
      />
      {open && (
        <Box
          as="ul"
          sx={{
            position: ['static', null, null, null, 'absolute'],
            top: '100%',
            left: 0,
            background: 'background.quaternary',
            border: ['none', null, null, null, 'tertiaryThin'],
            borderBottom: 'tertiaryThin',
            listStyle: 'none',
            minWidth: '296px',
            zIndex: 'header'
          }}
          role="menu"
        >
          {headerItem.items.map(item => (
            <Box as="li" key={item.label} role="menuitem" sx={{ width: '100%' }}>
              <Link href={item.url} variant="subNavigation">
                {item.label}
              </Link>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default MenuDropdown
